import { Routes, Route } from 'react-router-dom';
import { MoneyDashboard } from './MoneyDashboard';
import { InvoiceList } from './invoices/InvoiceList';
import { InvoiceDetail } from './invoices/InvoiceDetail';
import { CreateInvoice } from './invoices/CreateInvoice';
import { CustomerList } from './customers/CustomerList';
import { ExpenseManagement } from './expenses/ExpenseManagement';
import { FinancialReports } from './reports/FinancialReports';
import { GeneralLedger } from './accounting/GeneralLedger';
import { PlaceholderPage } from '../../components/PlaceholderPage';
import { SalesCRM } from './sales/SalesCRM';
import { Procurement } from './procurement/Procurement';
import { VendorBills } from './bills/VendorBills';
import { Billing } from './billing/Billing';
import { FinOps } from './finops/FinOps';
import { TaxCenter } from './tax/TaxCenter';

export function MoneyHub() {
  return (
    <div className="money-hub">
      <Routes>
        {/* Dashboard */}
        <Route index element={<MoneyDashboard />} />

        {/* Accounting / General Ledger */}
        <Route path="/accounting" element={<GeneralLedger />} />
        <Route path="/accounting/ar" element={<InvoiceList />} />

        {/* Invoices (AR) */}
        <Route path="/invoices" element={<InvoiceList />} />
        <Route path="/invoices/new" element={<CreateInvoice />} />
        <Route path="/invoices/:id" element={<InvoiceDetail />} />

        {/* Customers */}
        <Route path="/customers" element={<CustomerList />} />

        {/* Sales CRM */}
        <Route path="/sales" element={<SalesCRM />} />

        {/* Procurement (P2P) */}
        <Route path="/procurement" element={<Procurement />} />
        <Route path="/bills" element={<VendorBills />} />

        {/* Billing & Subscriptions */}
        <Route path="/billing" element={<Billing />} />

        {/* Expense Management */}
        <Route path="/expenses" element={<ExpenseManagement />} />

        {/* Cloud Costs / FinOps */}
        <Route path="/finops" element={<FinOps />} />

        {/* Tax Center */}
        <Route path="/tax" element={<TaxCenter />} />

        {/* Financial Reports */}
        <Route path="/reports" element={<FinancialReports />} />
      </Routes>
    </div>
  );
}
